import { action } from 'satcheljs';

export interface FlexPaneOpenedActionMessage {
    flexPaneId: string;
    targetWindow?: Window;
}
const flexPaneOpened: (flexPaneId: string, targetWindow?: Window) => FlexPaneOpenedActionMessage =
    action(
        'flexPaneOpened',
        (flexPaneId: string, targetWindow?: Window): FlexPaneOpenedActionMessage => ({
            flexPaneId,
            targetWindow,
        })
    );

export default flexPaneOpened;
